import {
  TableField,
  defaultTruncaTexto,
} from "../../table-field";

const nomeEvento = {
  key: "NmEvento",
  label: "Nome do Evento",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
  formatter: defaultTruncaTexto,
};

const tipo = {
  key: "DeTipoEvento",
  label: "Tipo",
  tdClass: ["align-middle, quebrarPorPalavraHard"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};

const actions = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "min20rem"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsProgramacoesEventoConsulta: TableField[] = [
  nomeEvento,
  tipo,
  actions,
];
